import { useEffect, useState } from 'react';
export function useLoadStylesheet(_a) {
    var url = _a.url;
    var _b = useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    useEffect(function () {
        var existingLink = document.querySelectorAll("[href=\"".concat(url, "\"]"));
        if (existingLink.length) {
            setIsLoaded(true);
            return;
        }
        function handleLoad() {
            setIsLoaded(true);
        }
        function handleError(error) {
            console.error({
                error: error,
                message: 'Failed to load stylesheet',
                tag: { name: 'load-stylesheet-error', value: 'true' },
                level: 'info',
                metadata: { url: url },
            });
        }
        var stylesheet = document.createElement('link');
        stylesheet.setAttribute('href', url);
        stylesheet.setAttribute('rel', 'stylesheet');
        stylesheet.addEventListener('load', handleLoad);
        stylesheet.addEventListener('error', handleError);
        document.head.appendChild(stylesheet);
        return function () {
            stylesheet.removeEventListener('load', handleLoad);
            stylesheet.removeEventListener('error', handleError);
        };
    }, [url]);
    return { isLoaded: isLoaded };
}
